import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchLeadsListApi,
  LeadItem,
  LeadsResponse,
} from "../services/API";
import { RootState } from "./store";

interface OrderState {
  leads: LeadItem[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  totalMessagesCount: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

const initialState: OrderState = {
  leads: [],
  status: "idle",
  error: null,
  totalMessagesCount: 0,
  totalPages: 0,
  hasNextPage: false,
  hasPrevPage: false,
};

interface FetchLeadsListArgs {
  time: string;
  template_id: string,
  status: string;
  page: number;
}

//fetch leads list
export const fetchLeadsList = createAsyncThunk<
    LeadsResponse,
    FetchLeadsListArgs,
  { rejectValue: string; state: RootState }
>(
  "chat/fetchLeadsList",
  async (
    { time, template_id, status, page }: FetchLeadsListArgs,
    { rejectWithValue, getState }
  ) => {
    const state = getState() as RootState;
    const token = state.auth.token;

    console.log("Fetching leads list withdd:", {
      time,
      status,
      token,
    });

    if (!token) {
      return rejectWithValue("Authentication token is missing");
    }

    try {
      const data = await fetchLeadsListApi(time,template_id, status, token, page);
      console.log("leads", data);
      return data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "An error occurred"
      );
    }
  }
);

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    resetLeads(state) {
      state.leads = [];
      state.status = "idle";
      state.error = null;
      state.totalMessagesCount = 0;
      state.totalPages = 0;
      state.hasNextPage = false;
      state.hasPrevPage = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeadsList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        fetchLeadsList.fulfilled,
        (state, action: PayloadAction<LeadsResponse>) => {
          state.status = "succeeded";
          //state.orders = [...state.orders, ...action.payload.orders];
          state.leads = action.payload.leads;
          state.totalMessagesCount = action.payload.totalMessagesCount;
          state.totalPages = action.payload.totalPages;
          state.hasNextPage = action.payload.hasNextPage;
          state.hasPrevPage = action.payload.hasPrevPage;
        }
      )
      .addCase(fetchLeadsList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "An error occurred";
      })
  },
});

export const { resetLeads } = leadSlice.actions;
export default leadSlice.reducer;
